import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { duration: { type: Number, default: 3000 } }

  connect() {
    this.limitToasts(3)
    this.startTimer()
    this.element.addEventListener("mouseenter", this.pause)
    this.element.addEventListener("mouseleave", this.resume)
  }

  disconnect() {
    clearTimeout(this.timer)
    this.element.removeEventListener("mouseenter", this.pause)
    this.element.removeEventListener("mouseleave", this.resume)
  }

  dismiss() {
    clearTimeout(this.timer)
    this.element.addEventListener("animationend", () => this.element.remove(), { once: true })
    this.element.style.animation = "toast-out 200ms ease forwards"
  }

  startTimer() {
    this.timer = setTimeout(() => this.dismiss(), this.durationValue)
  }

  pause = () => {
    clearTimeout(this.timer)
  }

  resume = () => {
    this.startTimer()
  }

  limitToasts(max) {
    const container = this.element.parentElement
    if (!container) return

    const toasts = container.querySelectorAll("[data-controller~=toast]")
    if (toasts.length > max) {
      // Remove oldest (first) toasts beyond the limit
      const excess = toasts.length - max
      for (let i = 0; i < excess; i++) {
        toasts[i].remove()
      }
    }
  }
}
